<template>
    <div :class="{rechargeBoxDark: isDark}">
        <van-skeleton :row="40" :loading="loadingInit" style="padding-top: 20px; padding-bottom: 20px; height: 100vh; overflow: hidden;">
            <div class="recharge" :class="{rechargeDark: isDark}" v-show="!paymentResultsShow">
                <!-- <u-loading-page  style="z-index: 100" :loading="loadingInit" loading-mode="semicircle" icon-size="36" bg-color="#F4F8FB" loadingMode="semicircle"></u-loading-page> -->
                <div class="rechargeBox">
                    <div class="upperHalfContainer">
                        <div class="priceBox">
                            <div class="topPrice">
                                <div class="title">
                                    嗨币余额<div class="theDetail" @click="goTheDetail">明细></div>
                                </div>
                                <div class="HaiBi">
                                    {{ userInfo ? parseFloat(userInfo.balance).toFixed(2) : '0.00' }}
                                </div>
                                <div class="rechargeTips" v-if="pay_order_msg">
                                    {{pay_order_msg}}
                                </div>
                            </div>
                            <div class="logoImg" v-if="first_pay_logo">
                                <div class="mainImg">
                                    <img :src="first_pay_logo" alt="">
                                </div>
                            </div>
                            <div class="bottomPrice">
                                <div class="item" v-for="(item, index) in priceList" :key="index" @click="setAmount(item.price)" :class="{active: currentPrice == item.price}">
                                    <div class="num">{{item.price}}嗨币</div>
                                    <div class="yuan">{{item.price}}元</div>
                                    <div class="gifts" v-if="giftsCalculate(item.price) && (first_pay_status * 1)">+{{giftsCalculate(item.price)}}通用嗨币红包</div>
                                </div>
                                <div class="item" :class="{active: otherActive}">
                                    <div class="num inputOther">
                                        <input type="number"
                                            v-model="otherPrice"
                                            placeholder="其他金额"
                                            maxlength="7"
                                            :focus="focusFlag"
                                            @focus="focusFlag = true"
                                            @blur="focusFlag = false"
                                        />
                                        <div class="element">元</div>
                                    </div>
                                    <div class="gifts" v-if="first_pay_status * 1">{{giftsCalculate(otherPrice) ? `+${giftsCalculate(otherPrice)}通用嗨币红包` : '额外赠送10%'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="titleNav">
                            选择支付方式
                        </div>
                        <div class="methodOfPayment" v-if="payList">
                            <div class="item" v-for="(item, index) in payList" :key="index" @click="tabs = item">
                                <div class="left">
                                    <template v-if="item.type == 'alipay'">
                                        <img src="https://jhimg.oss-cn-beijing.aliyuncs.com/mz/img/alipay.png" alt="">
                                    </template>
                                    <template v-else-if="item.type == 'wechat_pay'">
                                        <img src="https://jhimg.oss-cn-beijing.aliyuncs.com/mz/img/weixin.png" alt="">
                                    </template>
                                    {{ item.name }}<div class="sub_name">{{item.sub_name}}</div>
                                </div>
                                <div class="right">
                                    <img v-if="tabs.pay_type == item.pay_type && tabs.trade_type == item.trade_type && tabs.type == item.type && tabs.fourth_party == item.fourth_party" src="https://jhimg.oss-cn-beijing.aliyuncs.com/mz/img/selected.png" alt="">
                                    <img v-else src="https://jhimg.oss-cn-beijing.aliyuncs.com/mz/img/uncheck.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="titleNav">
                        充值说明
                        <div class="tips">
                            (添加24小时微信客服:jihaitiyu, 备注“充值”)
                        </div>
                    </div>
                    <div class="instructions">
                        <div class="text">
                            <div class="number">1.</div>
                            <div class="content">
                                充值1元=1嗨币，嗨币可用于查看作者推荐，参与嗨聊，购买即嗨数据包月等；
                            </div>
                        </div>
                        <div class="text">
                            <div class="number">2.</div>
                            <div class="content">
                                嗨币不支持退款；
                            </div>
                        </div>
                        <div class="text">
                            <div class="number">3.</div>
                            <div class="content">
                                最终解释权归即嗨体育所有。
                            </div>
                        </div>
                    </div>
                    <div class="agreement">
                        <van-checkbox v-model="flag" shape="square" icon-size="16px"></van-checkbox>
                        我已阅读并同意<div class="theHighlighted"  @click="goAgreement('user')">《用户服务条款》</div>
                        <!-- 和<div  @click="goAgreement('privacy')" class="theHighlighted">《隐私政策》</div> -->
                    </div>
                </div>
                <van-dialog v-model="rechargeModel" :showConfirmButton="false">
                    <div class="rechargeModelBox">
                        <div class="title">嗨币充值说明</div>
                        <div class="subTitle">你正在进行嗨币充值</div>
                        <div class="text">1.嗨币可用于购买付费阅读，每日精选数据包月。</div>
                        <div class="text">2.嗨币购买后不支持退换。</div>
                        <van-button type="info" block round :disabled="(rechargeTime ? true : false)" @click="agreeRecharge">
                            {{ rechargeTime ? `同意并充值（${rechargeTime}）` : '同意并充值' }}
                        </van-button>
                    </div>
                </van-dialog>
                <van-popup round v-model="paymentReminderShow" :close-on-click-overlay="false">
                    <div class="payNoticeModel">
                        <h2>网上支付提示</h2>
                        <p>支付完成前，请不要关闭此支付验证弹窗</p>
                        <p>支付完成后，请根据您的支付情况点击下面的按钮</p>
                        <div class="btnBox">
                            <span class="cancel" @click="payOk">支付遇到问题</span>
                            <span class="ok" @click="payOk(1)">支付完成</span>
                        </div>
                    </div>
                </van-popup>
                <div class="placeholder"></div>
                <div class="footer">
                    <div class="btn" @click="Pay">立即支付</div>
                </div>
            </div>
        </van-skeleton>
        <div v-html="ali_xz_pay_url"></div>
        <PaymentResults  v-show="paymentResultsShow" :paymentResultsShow="paymentResultsShow" :balance="userInfo ? parseFloat(userInfo.balance).toFixed(2) : '0.00'" type="recharge" :trade_no="trade_no" />
    </div>
</template>

<script>
import { getPayRechargeConfig, getPayRechargePay, getUserInfo, getPayStatus, getSellPriceList } from "@/api/user"
import { handleLocalStorage, GetCookie } from "@/utils/base";
import jsbridg from "@/utils/jsbridg"
import PaymentResults from "@/components/user/paymentResults"
export default {
    name: "recharge",
    components: {
        PaymentResults
    },
    data () {
        return {
            ali_xz_pay_url: '',
            src: (this.$route.query.src instanceof Array) ? this.$route.query.src[0] : this.$route.query.src,
            paymentReminderShow: false,
            rechargeModel: !handleLocalStorage('get', 'rechargeModel'),
            rechargeTime: 5,
            rechargeTimer: null,
            tabs: {},
            payList: null,
            app_channel: GetCookie('app_channel'),
            priceList: [],
            gearList: [
                {
                    price: 50
                },
                {
                    price: 100
                },
                {
                    price: 208
                },
                {
                    price: 688
                },
                {
                    price: 1288
                }
            ],
            currentPrice: "",
            flag: true,
            otherPrice: '',
            otherActive: false,
            focusFlag: false,
            loadingInit: true,
            userInfo: null,
            // 弹框红包逻辑
            pay_order_msg: '',
            first_pay_logo: '',
            first_pay_status: 0,
            first_pay_bfb: '',
            paymentResultsShow: false,
            trade_no: '',
            sreturnModel: this.$route.query.sreturnModel
        }
    },
    watch: {
        focusFlag (news) {
            if (news) {
                this.currentPrice = ''
                this.otherActive = true
            }
        }
    },
    async created () {
        document.getElementsByTagName('title')[0].innerHTML = "充值"
        if (this.sreturnModel) {
            jsbridg.closeWebview()
        }
        this.paymentCallback()
        if (this.rechargeModel) {
            this.rechargeTimer = setInterval(() => {
                if (this.rechargeTime === 0) {
                    clearInterval(this.rechargeTimer)
                    return
                }
                this.rechargeTime--
            }, 1000)
        }
        jsbridg.rechargeNotice()
        await this.getPayRechargeConfig()
        await this.getUserInfo()
        await this.getSellPriceList()
        this.loadingInit = false
        await this.getPayStatus()
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    methods: {
        giftsCalculate (price) {
            const num = Math.ceil(price / 10)
            return num
        },
        async getSellPriceList () {
            const params = {
                src: this.src
            }
            const res = await getSellPriceList(params)
            if (res.errno * 1 === 0) {
                this.priceList = res.data
                if (res.data.findIndex(item => item.is_check * 1 === 1) > -1) {
                    this.currentPrice = res.data[res.data.findIndex(item => item.is_check * 1)].price
                }
            } else {
                this.$toast.fail(res.errmsg);
            }
        },
        async getPayStatus () {
            const params = {
                src: this.src
            }
            const res = await getPayStatus(params)
            if (res.errno * 1 === 0) {
                if (res.data && res.data.pay_order_msg) {
                    this.pay_order_msg = res.data.pay_order_msg
                }
                if (res.data && res.data.first_pay_logo) {
                    this.first_pay_logo = res.data.first_pay_logo
                }
                if (res.data && res.data.first_pay_status) {
                    this.first_pay_status = res.data.first_pay_status
                }
                if (res.data && res.data.first_pay_bfb) {
                    this.first_pay_bfb = res.data.first_pay_bfb
                }
            } else {
                this.$toast.fail(res.errmsg);
            }
        },
        payOk () {
            this.paymentReminderShow = false
            // this.getUserInfo()
            this.paymentResultsShow = true
        },
        paymentCallback () {
            // app支付完成回调函数
            window.appPaycallback = (data) => {
                if (data === 'ok') {
                    this.$toast.success('支付成功');
                    this.getUserInfo()
                    this.getPayStatus()
                } else if (data === 'error') {
                    this.$toast.fail('未知错误，请联系客服！');
                }
            };
        },
        async getUserInfo () {
            const res = await getUserInfo()
            if (res.errno * 1 === 0) {
                this.userInfo = res.data
            } else {
                this.$toast.fail(res.errmsg);
            }
        },
        // 同意嗨币充值协议
        agreeRecharge () {
            handleLocalStorage('set', 'rechargeModel', true)
            this.rechargeModel = false
        },
        thePopUp () {
            this.currentPrice = ''
            this.otherActive = true
        },
        goAgreement (name) {
            if (name === 'user') {
                const URL = process.env.VUE_APP_H5_DOMAIN + '/page/privacy?type=user'
                window.location.href = URL
                // jsbridg.goWebview({
                //     url: URL,
                //     jumptype: 2
                // });
            }
        },
        Pay () {
            if (this.currentPrice) {
                this.getPayRechargePay(this.currentPrice)
            } else if (this.otherPrice) {
                this.getPayRechargePay(this.otherPrice)
            } else {
                this.$toast.fail('请输入金额！');
            }
        },
        setAmount (price) {
            this.otherActive = false
            this.currentPrice = price
        },
        async getPayRechargePay (price) {
            this.$toast.loading({
                message: '正在支付中...',
                forbidClick: true,
                loadingType: 'spinner',
                duration: 0
            });
            if (!this.flag) {
                this.$toast.fail('请先同意用户协议！');
                return
            }
            const params = {
                amount: price,
                pay_type: this.tabs.pay_type,
                trade_type: this.tabs.trade_type,
                fourth_party: this.tabs.fourth_party,
                return_url: window.encodeURI(this.encapsulationUrl(this.tabs.pay_type)),
                src: this.src
            }
            if (this.first_pay_status * 1) {
                params.ext_info = JSON.stringify({
                    first_pay_status: this.first_pay_status
                })
            }
            const res = await getPayRechargePay(params)
            this.$toast.clear()
            if (res.errno * 1 === 0) {
                if (this.tabs.type === 'alipay') {
                    this.trade_no = res.data.trade_no
                    if (this.tabs.trade_type === 'OTA') {
                        this.paymentReminderShow = true
                        window.location.href = res.data.target_url
                    } else if (this.tabs.trade_type === 'APP') {
                        jsbridg.appAliPay(res.data.sdk_data)
                    } else {
                        this.paymentReminderShow = true
                        jsbridg.goWebview({
                            url: res.data.target_url,
                            jumptype: 2
                        });
                    }
                    // if (this.tabs.pay_type === 'ali_xz') {
                    //     // window.open(res.data.target_url)
                    //     jsbridg.goWebview({
                    //         url: res.data.target_url,
                    //         jumptype: 2
                    //     });
                    //     // this.ali_xz_pay_url = `
                    //     //     <form target="_self" method="get" action="${res.data.target_url}" name="ali_xz"></form>
                    //     // `
                    //     // this.$nextTick(() => {
                    //     //     document.forms.ali_xz.submit()
                    //     // })
                    // } else {
                    //     jsbridg.goWebview({
                    //         url: res.data.target_url,
                    //         jumptype: 2
                    //     });
                    // }
                } else if (this.tabs.type === 'wechat_pay' && this.tabs.trade_type !== 'OTA') {
                    jsbridg.appWXPay(res.data)
                } else {
                    this.paymentReminderShow = true
                    window.location.href = res.data.target_url
                }
            } else {
                this.$toast.fail(res.errmsg);
            }
        },
        encapsulationUrl () {
            if (window.location.href.indexOf('?') > -1) {
                return window.location.href.split('?')[0] + '?sreturnModel=1'
            } else {
                return window.location.href + '?sreturnModel=1'
            }
        },
        async getPayRechargeConfig () {
            const params = {
                scene: 'app',
                src: this.src
            }
            if (this.app_channel) {
                params.app_channel = this.app_channel
            }
            const res = await getPayRechargeConfig(params)
            if (res.errno * 1 === 0) {
                this.payList = res.data.list
                this.tabs = res.data.list[0]
            } else {
                this.$toast.fail(res.errmsg);
            }
        },
        goTheDetail () {
            const URL = process.env.VUE_APP_H5_DOMAIN + '/page/new_my#step10'
            window.location.href = URL
            // jsbridg.goWebview({
            //     url: URL,
            //     jumptype: 2
            // });
        }
    }
}
</script>

<style lang="less" scoped>
.recharge{
    .rechargeBox{
        min-height: 100vh;
        padding-bottom: 112 / 2px;
        background: #f5f5f5;
        .upperHalfContainer{
            background: #fff;
        }
        .priceBox{
            //height: 581 / 2px;
            padding-bottom: 25 / 2px;
            background: #FFFFFF;
            border-radius: 10 / 2px;
            .topPrice{
                height: 280 / 2px;
                background-image: url("https://jhimg.oss-cn-beijing.aliyuncs.com/mz/img/rechargeBack.png");
                background-repeat: no-repeat;
                background-size: 100%;
                padding: 62 / 2px;
                box-sizing: border-box;
                position: relative;
                //padding-bottom: ;
                .title{
                    display: flex;
                    align-items: center;
                    font-size: 32 / 2px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    .theDetail{
                        font-size: 26 / 2px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        margin-left: 40 / 2px;
                    }
                }
                .HaiBi{
                    margin-top: 10 / 2px;
                    font-size: 80 / 2px;
                    font-family: HelveticaNeue-CondensedBlack, HelveticaNeue;
                    font-weight: normal;
                    color: #FFFFFF;
                }
                .rechargeTips{
                    height: 20px;
                    width:  calc(100% - 20px);
                    background: #FF5048;
                    border-radius: 0px 0px 10px 10px;
                    opacity: 0.9;
                    font-size: 13px;
                    font-weight: 400;
                    color: #FFFFFF;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    bottom: 0;
                    left: 10px;
                }
            }
            .logoImg{
                padding: 0 14px;
                margin: 10px 0;
                .mainImg{
                    height: 58px;
                }
            }
            .bottomPrice{
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                padding-left: 28 / 2px;
                box-sizing: border-box;
                .item{
                    margin-top: 15 / 2px;
                    width: 214 / 2px;
                    height: 120 / 2px;
                    background: #EAF4FE;
                    border-radius: 8 / 2px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    margin-right: 26 / 2px;
                    position: relative;
                    .gifts{
                        padding: 0 5px;
                        height: 16px;
                        background: #FF5048;
                        border-radius: 6px 2px 6px 2px;
                        font-size: 10px;
                        color: #FFFFFF;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: absolute;
                        top: -8px;
                        right: -8px;
                    }
                    .num{
                        font-size: 32 / 2px;
                        font-weight: 400;
                        color: #169AFF;
                    }
                    .yuan{
                        font-size: 24 / 2px;
                        font-weight: 400;
                        color: #999999;
                    }
                    .inputOther{
                        height: 100%;
                        width: 100%;
                        position: relative;
                        .element{
                            position: absolute;
                            right: 15px;
                        }
                        input{
                            height: 100%;
                            // width: 107px;
                            text-align: left;
                            font-size: 32 / 2px;
                            position: absolute;
                            padding-left: 10px;
                            z-index: 2;
                            left: 0;
                            &::placeholder {
                                font-size: 32 / 2px;
                                color: #999;
                            }
                        //     &::placeholder {
                        //         font-size: 32 / 2px;
                        //         color: #169AFF !important;
                        //     }
                        //     ::-webkit-input-placeholder{   /* 使用webkit内核的浏览器 */
                        //         color: #169AFF !important;
                        //     }
                        //     :-moz-placeholder{    /* Firefox版本4-18 */
                        //         color: #169AFF !important;
                        //     }
                        //     ::-moz-placeholder{    /* Firefox版本19+ */
                        //         color: #169AFF !important;
                        //     }
                        //     :-ms-input-placeholder{   /* IE浏览器 */
                        //         color: #169AFF !important;
                        //     }
                        }
                        .uni-input-input{
                            &::placeholder {
                                font-size: 32 / 2px;
                                color: #169AFF !important;
                            }
                        }
                    }
                    &:last-child{
                        .num{
                            display: flex;
                            align-items: center;
                            input{
                                background: transparent;
                                width: 107px;
                                color: #169AFF;
                            }
                        }
                    }
                    &.active{
                        background-color: #169AFF;
                        transition: all .5s;
                        .num{
                            color: #fff;
                            input{
                                color: #fff;
                                &::placeholder {
                                    font-size: 32 / 2px;
                                    color: #fff !important;
                                }
                            }
                        }
                        .yuan{
                            color: #fff;
                        }
                    }
                }
            }
        }
        .titleNav{
            display: flex;
            align-items: center;
            font-size: 30 / 2px;
            font-weight: 600;
            color: #333333;
            height: 70 / 2px;
            margin-top: 15 / 2px;
            padding: 0 28 / 2px;
            .tips{
                color: #169AFF;
                font-size: 10px;
                margin-left: 5px;
                font-weight: 400;
            }
        }
        .methodOfPayment{
            padding: 0 28 / 2px;
            .item{
                height: 96 / 2px;
                background: #FFFFFF;
                border-radius: 10 / 2px;
                margin-bottom: 8 / 2px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #eee;
                .left{
                    display: flex;
                    align-items: center;
                    img{
                        width: 60 / 2px;
                        height: 60 / 2px;
                        margin-right: 10 / 2px;
                    }
                    font-size: 26 / 2px;
                    font-weight: 400;
                    color: #333333;
                    .sub_name{
                        font-size: 24 / 2px;
                        color: #999
                    }
                }
                .right{
                    img{
                        width: 40 / 2px;
                        height: 40 / 2px;
                    }
                }
            }
        }
        .instructions{
            padding: 0 28 / 2px;
            .text{
                display: flex;
                font-size: 24 / 2px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                margin-bottom: 10 / 2px;
            }
        }
        .agreement{
            padding: 0 28 / 2px;
            margin-top: 20 / 2px;
            display: flex;
            align-items: center;
            font-size: 22 / 2px;
            font-weight: 400;
            color: #999999;
            .theHighlighted{
                color: #169AFF;
            }
            /deep/.van-checkbox{
                font-size: 10px;
                margin-right: 5px;
            }
        }
    }
    .rechargeModelBox{
        padding: 0 15px;
        padding-bottom: 15px;
        .title{
            height: 45px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            color: #333;
            font-weight: bold;
        }
        .subTitle{
            font-size: 13px;
            color: #333;
            margin-bottom: 8px;
        }
        .text{
            font-size: 12px;
            color: #999;
            margin-bottom: 8px;
        }
        /deep/.van-button{
            margin-top: 3px;
            height: 40px;
        }
    }
    /deep/.van-popup{
        width: 300px;
        .payNoticeModel{
            background: #fff;
            border-radius: 30px;
            padding-top: 10px;
            h2{
                text-align: center;
                font-size: 14px;
                line-height: 20px;
                color: #333333;
                margin-bottom: 15px;
                font-weight: bold;
            }
            p{
                padding: 0 16px;
                font-size: 12px;
                color: #666;
                line-height: 18px;
                text-align: left;
            }
            .btnBox{
                width: 100%;
                height: 40px;
                font-size: 13px;
                margin-top: 16px;
                border-top: 1px solid #eee;
                padding-top: 10px;
                span{
                    display: inline-block;
                    width: 50%;
                    color: #939393;
                    border-right: 1px solid #eee;
                    text-align: center;
                }
                .ok{
                    color: #495CFF;
                    border-right: 0;
                }
            }
        }
    }
    .placeholder{
        height: 58px;
    }
    .footer{
        display: flex;
        align-items: center;
        justify-content: center;
        background: #FFFFFF;
        box-shadow: 0 / 2px -2 / 2px 10 / 2px 0 / 2px rgba(0,0,0,0.1);
        position: fixed;
        bottom: 0;
        width: 100%;
        padding: 0  28 / 2px;
        padding-bottom: 20px;
        padding-top: 8px;
        .btn{
            flex: 1;
            height: 88 / 2px;
            background: #169AFF;
            border-radius: 10 / 2px;
            font-size: 30 / 2px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
.rechargeBoxDark{
    /deep/.van-skeleton{
        .van-skeleton__row{
            background-color: #2f2f2f !important;
        }
    }
}
.rechargeDark{
    .rechargeBox{
        background: #232323;
        .upperHalfContainer{
            background: #191919;
        }
        .priceBox{
            background: #191919;
            .topPrice{
                .title{
                    color: #d3d3d3;
                    .theDetail{
                        color: #d3d3d3;
                    }
                }
                .HaiBi{
                    color: #d3d3d3;
                }
            }
            .bottomPrice{
                .item{
                    background: #232323;
                    .yuan{
                        color: #a6a6a6;
                    }
                    &.active{
                        .num{
                            color: #d3d3d3;
                            &::placeholder {
                                font-size: 32 / 2px;
                                color: #d3d3d3 !important;
                            }
                        }
                        .yuan{
                            color: #d3d3d3
                        }
                    }
                }
            }
        }
        .titleNav{
            color: #d3d3d3;
        }
        .methodOfPayment{
            .item{
                border-color: #232323;
                background: #191919;
                .left{
                    color: #d3d3d3;
                }
            }
        }
        .instructions{
            .text{
                color: #a6a6a6;
            }
        }
        .agreement{
            color: #a6a6a6;
        }
    }
    .rechargeModelBox{
        background: #191919;
        .title{
            color: #d3d3d3;
        }
        .subTitle{
            color: #d3d3d3;
        }
        .text{
            color: #a6a6a6;
        }
    }
    /deep/.van-popup{
        background: #191919;
        .payNoticeModel{
            background: #191919;
            h2{
                color: #d3d3d3;
            }
            p{
                color: #a6a6a6;
            }
            .btnBox{
                border-color: #232323;
                span{
                    color: #a6a6a6;
                    border-color: #232323;
                }
            }
        }
    }
    .footer{
        background: #191919;
         box-shadow: 0 / 2px -2 / 2px 10 / 2px 0 / 2px rgba(255,255,255,0.1);
        .btn{
            color: #d3d3d3;
        }
    }
}
</style>
